import {DumpsterFire} from "../DumpsterFire";
import {StageLayer} from "@nolimitcity/slot-keypad/bin/core/app/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-keypad/bin/core/app/NolimitApplication";

export class GameLogo extends PIXI.Container implements StageLayer {
    private _logo: PIXI.Sprite;

    constructor() {
        super();
        this.name = "GameLogo";
        this.init();
    }

    public setMode(mode: string): void {
        if (mode.indexOf("FREESPIN") > -1 && !(DumpsterFire.model.data.nextMode.indexOf("NORMAL") > -1) && DumpsterFire.model.data.upgradedSymbols.length > 0) {
            if (NolimitApplication.isLandscape) {
                this._logo.position.set(-260, 0);
            } else {
                this._logo.position.set(250, -200);
            }
        } else if (mode.indexOf("EXTRA_SPIN") > -1 && DumpsterFire.model.data.mode.indexOf("FREESPIN") > -1 && DumpsterFire.model.data.upgradedSymbols.length > 0) {
            if (NolimitApplication.isLandscape) {
                this._logo.position.set(-260, 0);
            } else {
                this._logo.position.set(250, -200);
            }
        } else if (mode.indexOf("EXTRA_SPIN") > -1 && DumpsterFire.model.data.mode.indexOf("NORMAL") > -1) {
            if (NolimitApplication.isLandscape) {
                this._logo.position.set(-260, 0);
            } else {
                this._logo.position.set(245, -122);
            }
        } else {
            if (NolimitApplication.isLandscape) {
                this._logo.position.set(-260, 0);
            } else {
                this._logo.position.set(245, -122);
            }
        }
    }

    public isIPadDevice(): boolean {
        if (NolimitApplication.isLandscape)
            return (NolimitApplication.screenBounds.width >= 955 && NolimitApplication.screenBounds.width <= 965);
        else
            return (NolimitApplication.screenBounds.height >= 955 && NolimitApplication.screenBounds.height <= 965);
    }

    public onResize(): void {
        if (NolimitApplication.isLandscape) {
            this._logo.visible = !this.isIPadDevice();
        } else {
            this._logo.visible = !this.isIPadDevice();
        }

        if (DumpsterFire.model.isFreespin) {
            if (NolimitApplication.isLandscape) {
                this._logo.position.set(-260, 0);
            } else {
                this._logo.position.set(250, -200);
            }
        } else {
            if (NolimitApplication.isLandscape) {
                this._logo.position.set(-260, 0);
            } else {
                this._logo.position.set(245, -122);
            }
        }
    }

    private init() {
        this._logo = new PIXI.Sprite(DumpsterFire.assetLoader.getTextures("logo2")[0]);
        this._logo.position.set(-280, 0);
        this.addChild(this._logo)
        this.onResize();
    }
}